import React from "react";

const LandingPage = () => {
    window.location.href = window.location.protocol + "//" + window.location.host + '/my-account/';
    return null;
}

export const ProductPage = () => {
    window.location.href = window.location.protocol + "//" + window.location.host + '/product/horse-profile/';
    return null;
}

export default LandingPage
